module.exports = __webpack_public_path__ + "img/banner002.34012039.jpg";